<template>
  <div class="text-center">
    <h3>{{ location.name }}</h3>
    <iframe id="gmap_canvas"
      :src="'https://maps.google.fr/maps?q='+location.maps+'&ie=UTF8&z=12&iwloc=&output=embed'"
      frameborder="0" scrolling="no" marginheight="0" marginwidth="0" class="location"></iframe>
  </div>
</template>

<script>
export default {
  name: 'Location',
  props: ['location'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.location{
  width: 100%;
  max-width: 300px;
}

</style>
